// the simple interaction event/widget editing view which corresponds to CS1Surveys
// MVP - compatible

import React, { useRef } from 'react';
import TextField from "@mui/material/TextField";
import Interaction from "../../../../../models/interactions/Interaction";

interface AccountInteractionProps {
    interaction: Interaction;
    handleAccountNameMapping: (value: string) => void;
}

const Account = (props: AccountInteractionProps) => {
    const textFieldRef = useRef<HTMLInputElement>(null);
    
    const handleTextFieldClick = () => {
      if (textFieldRef.current) {
        textFieldRef.current.select();
      }
    };
    
    // the cs1survey event type is very simple, and only needs to receive 1 setting right now: the mapped PRO
    return (
        <div>
            <div style={{ padding: "10px" }}>
                <TextField
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        props.handleAccountNameMapping(event.target.value);
                    }}
                    sx={{ width: "99%" }}
                    id="outlined-required"
                    label="Account Title"
                    inputRef={textFieldRef}
                    onClick={handleTextFieldClick}
                    defaultValue={props.interaction.title}
                />
            </div>
        </div>
    );
};

export default Account;
